export enum MediaType {
    image = "15c6f642-6fc2-4d4e-9d91-5feb55ffe90a",
    video = "46cf7098-f494-431f-a55f-fed9cb09cf90",
    pdf = "3ba4aed5-8708-45a6-a047-35749eb7c7b2",
    audio = "0ba0ca04-0b92-4478-ad84-c58c2f3c4fdc",
    unknown = "2ee597d1-4b3f-4574-8032-1e112db3322c",
};
